/* eslint-disable @typescript-eslint/naming-convention */
export enum OrderStatus {
  Shipped = 'Shipped',
  Processing = 'Processing', // State before shipping
  PartiallyShipped = 'PartiallyShipped',
  OnHold = 'OnHold',
  Cancelled = 'Cancelled',
}
